import styled from 'styled-components';
import { color } from 'styles/settings';

export const BulkSelectWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2;
`;

export const Indicator = styled.div`
  position: absolute;
  border: 1px solid ${color.brand.blueLight};
`;

export const Background = styled.div`
    width: 100%;
    height: 100%;
    background-color ${color.brand.blueLight};
    opacity: 0.3;
`;
